export default {"src":"/_next/static/media/salt.5a051ea4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};